import React, { useState } from 'react';

// Interfejs propsów dla naszego komponentu przycisku
interface SaveButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

// --- Komponent przycisku ze stylami inline i poprawnym typowaniem ---
export const Button: React.FC<SaveButtonProps> = ({ children, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const baseStyle: React.CSSProperties = {
    backgroundColor: '#FFFFFF',
    border: '0',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    color: '#111827',
    fontFamily: '"Inter var", ui-sans-serif, system-ui, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
    fontSize: '0.875rem',
    fontWeight: '600',
    lineHeight: '1.25rem',
    padding: '0.75rem 1rem',
    textAlign: 'center',
    textDecoration: 'none',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    touchAction: 'manipulation',
    transition: 'all 0.3s ease-in-out'
  };

  // Style dodawane po najechaniu kursorem
  const hoverStyle: React.CSSProperties = {
    backgroundColor: 'rgb(249, 250, 251)',
    borderRadius: '1rem' // Efekt zaokrąglonych rogów
  };

  // Style dla przycisku w stanie wyłączonym
  const disabledStyle: React.CSSProperties = {
    backgroundColor: '#E5E7EB',
    color: '#6B7280',
    cursor: 'not-allowed'
  };

  // Łączenie stylów w zależności od stanu komponentu
  const combinedStyle: React.CSSProperties = {
    ...baseStyle,
    ...(isHovered && !props.disabled ? hoverStyle : {}),
    ...(props.disabled ? disabledStyle : {})
  };

  return (
    <button
      {...props}
      style={combinedStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );
};